import { render, staticRenderFns } from "./BranchInfoWidget.vue?vue&type=template&id=34a594c0&scoped=true"
import script from "./BranchInfoWidget.vue?vue&type=script&lang=js"
export * from "./BranchInfoWidget.vue?vue&type=script&lang=js"
import style0 from "./BranchInfoWidget.vue?vue&type=style&index=0&id=34a594c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a594c0",
  null
  
)

/* custom blocks */
import block0 from "./BranchInfoWidget.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports